import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Stack } from "@fluentui/react/lib/Stack";

import { IWithThemeProps } from "Components/Generic/Theme/IWithThemeProps";
import { WithTheme } from "Components/Generic/Theme/WithTheme";
import { addressValidationDialog } from "Store/Actions";
import { selectShowAddressValidationDialog } from "Store/Selectors/Omikron";
import { Content } from "../Content";
import { Dialog } from "../Dialog";
import { DialogType } from "../Dialog/DialogType";
import { ProjectItemContextProvider } from "../ProjectItemContext/ProjectItemContextProvider";
import { useAddressValidationStyles } from "./UseAddressValidationStyles";
import { useAddressValidation } from "./UseAddressValidation";

export const AddressValidationWithContext = WithTheme(({ theme: { spacing } }: IWithThemeProps): JSX.Element => {
  const styles = useAddressValidationStyles();
  const dispatch = useDispatch();
  const isOpen = useSelector(selectShowAddressValidationDialog);
  const onDismiss = useCallback(() => dispatch(addressValidationDialog(false)), [dispatch]);

  const {
    cache, results, onSelect, onSave, onIsRelevant
  } = useAddressValidation();

  if (!isOpen) {
    return null;
  }

  return (
    <Dialog isOpen={isOpen} onDismiss={onDismiss} onSave={onSave}>
      <Stack className={styles.root} tokens={{ childrenGap: spacing.m }}>
        <Content cache={cache} results={results} onSelect={onSelect} onIsRelevant={onIsRelevant} />
      </Stack>
    </Dialog>
  );
});

export function AddressValidation(): JSX.Element {
  return (
    <ProjectItemContextProvider type={DialogType.AddressValidation}>
      <AddressValidationWithContext />
    </ProjectItemContextProvider>
  );
}
